<mat-progress-bar *ngIf="loading.value" mode="indeterminate" />
<mat-card class="cardWithShadow">

    <!-- Skeleton -->
    <div *ngIf="loading.value;" class="p-32">
        <ngx-skeleton-loader count="8" [theme]="{height: '30px'}" />
    </div>

    <!-- No Data -->
    <div *ngIf="!loading.value && !dataLength">
        <app-no-data *ngIf="!dataLength" />
    </div>

    <table mat-table [dataSource]="dataTable.data" matSort
        class="no-wrap m-t-0 v-middle w-100 {{hideData() ? 'd-none' : ''}}">

        <!-- Nome Column -->
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Nome </th>
            <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>

        <!-- Email Column -->
        <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
            <td mat-cell *matCellDef="let element"> {{element.email}} </td>
        </ng-container>

        <!-- Level Column -->
        <ng-container matColumnDef="level">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Tipo utente </th>
            <td mat-cell *matCellDef="let element"> {{getRoleNameById(element.level_id)}} </td>
        </ng-container>

        <!-- SiteName Column -->
        <ng-container matColumnDef="reference">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Riferimento </th>
            <td mat-cell *matCellDef="let element" style="gap: 13px;border-bottom: none;">
                <div *ngIf="element.level_id === userLevel.SITE" class="d-flex" style="gap: 13px;">
                    <div *ngFor="let item of element.sitesDetails" class="f-s-12 d-flex">
                        <a [routerLink]="['/administration/site/',item.siteId]">{{item.siteName}}</a>
                    </div>
                </div>
                <div *ngIf="element.level_id === userLevel.CER" class="d-flex" style="gap: 13px;">
                    <div *ngFor="let item of element.cersDetails" class="f-s-12 d-flex">
                        <a [routerLink]="['/administration/cer/',item.cerId]">{{item.cerName}}</a>
                    </div>
                </div>
            </td>
        </ng-container>

        <!-- Enabled Column -->
        <ng-container matColumnDef="state">
            <th mat-header-cell *matHeaderCellDef> Stato </th>
            <td mat-cell *matCellDef="let element">
                <app-status-label *ngIf="element.enabled" [text]="statuses.active.text"
                    [color]="statuses.active.color"></app-status-label>
                <app-status-label *ngIf="!element.enabled" [text]="statuses.unactive.text"
                    [color]="statuses.unactive.color"></app-status-label>
            </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Azioni </th>
            <td mat-cell *matCellDef="let element">
                <button mat-icon-button [routerLink]="['/administration/users', element.id]"
                    routerLinkActive="router-link-active">
                    <i-tabler name="file-pencil" class="icon-25 text-primary"></i-tabler>
                </button>
                <a (click)="delete(element.id)" matTooltip="Elimina" mat-icon-button class="text-error">
                    <mat-icon>
                        <i-tabler name="trash" />
                    </mat-icon>
                </a>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row">
        </tr>
    </table>

    <mat-paginator *ngIf="dataLength && pagination" [pageSizeOptions]="[10, 25, 50]" [length]="dataLength"
        [pageSize]="pageSize" showFirstLastButtons (page)="handlePageEvent($event)" />
</mat-card>

<!-- Row shown when there is no matching data. -->
<ng-template class="mat-row" #matNoDataRow>
    <div colspan="4">Nessun dato per i filtri impostati</div>
</ng-template>